import React, { useState } from 'react';

const todayIso = () => new Date().toISOString().split('T')[0];

const SchoolChildModal = ({ isOpen, onClose, onSubmit }) => {
    const [hasChild, setHasChild] = useState(null);
    const [childName, setChildName] = useState('');
    const [birthDate, setBirthDate] = useState('');

    const handleNoClick = () => {
        onSubmit({
            status: 'dismissed'
        });
        onClose();
    };

    const handleYesClick = () => {
        setHasChild(true);
    };

    const handleSubmit = () => {
        if (!childName) return;
        onSubmit({
            status: 'completed',
            child: {
                name: childName,
                birthDate: birthDate || null
            }
        });
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[150] p-4 transition-all animate-in fade-in">
            <div className="bg-white dark:bg-slate-900 rounded-3xl max-w-md w-full p-8 shadow-2xl border border-white/10 dark:border-white/5 relative overflow-hidden">
                {/* Decorative background element */}
                <div className="absolute -top-12 -right-12 w-32 h-32 bg-blue-500/10 rounded-full blur-3xl"></div>
                <div className="absolute -bottom-12 -left-12 w-32 h-32 bg-indigo-500/10 rounded-full blur-3xl"></div>

                {/* Close Icon */}
                <button
                    onClick={onClose}
                    className="absolute top-6 right-6 p-2 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 transition-colors z-10"
                >
                    <span className="material-symbols-outlined text-[24px]">close</span>
                </button>

                {/* Header */}
                <div className="text-center mb-8 relative z-10">
                    <div className="text-5xl mb-4">🍱</div>
                    <h2 className="text-2xl font-black text-slate-900 dark:text-white mb-3 tracking-tight">
                        Beslenme Çantasını Dert Etmeyin!
                    </h2>
                    <p className="text-slate-600 dark:text-slate-400 text-sm font-medium leading-relaxed">
                        Mutfaktaki malzemelerle çocuğunuz için pratik ve besleyici beslenme çantası tarifleri hazırlamanıza yardımcı olabiliriz.
                    </p>
                </div>

                {/* Initial Choice Buttons */}
                {hasChild === null && (
                    <div className="space-y-4 relative z-10">
                        <button
                            onClick={handleYesClick}
                            className="w-full p-5 bg-blue-600 hover:bg-blue-700 text-white rounded-2xl transition-all font-bold text-lg flex items-center justify-center gap-3 shadow-lg shadow-blue-500/20 active:scale-[0.98]"
                        >
                            <span className="material-symbols-outlined">school</span>
                            Evet, Çocuğum Var!
                        </button>

                        <button
                            onClick={handleNoClick}
                            className="w-full p-5 bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-600 dark:text-slate-300 rounded-2xl transition-all font-bold text-base active:scale-[0.98]"
                        >
                            Şimdilik İhtiyacım Yok
                        </button>
                    </div>
                )}

                {/* Details Entry */}
                {hasChild === true && (
                    <div className="space-y-6 relative z-10 animate-in slide-in-from-right-4 duration-300">
                        <div className="space-y-4">
                            <div className="space-y-2">
                                <label className="block text-xs font-black text-slate-500 dark:text-slate-400 uppercase tracking-widest px-1">Çocuğunuzun Adı</label>
                                <input
                                    type="text"
                                    placeholder="Can, Elif vb."
                                    value={childName}
                                    onChange={(e) => setChildName(e.target.value)}
                                    className="w-full p-4 rounded-2xl bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-900 dark:text-white focus:border-blue-500 focus:ring-4 focus:ring-blue-100 dark:focus:ring-blue-900/30 transition-all font-bold"
                                />
                            </div>

                            <div className="space-y-2">
                                <label className="block text-xs font-black text-slate-500 dark:text-slate-400 uppercase tracking-widest px-1">Doğum Tarihi (Opsiyonel)</label>
                                <input
                                    type="date"
                                    max={todayIso()}
                                    value={birthDate}
                                    onChange={(e) => setBirthDate(e.target.value)}
                                    className="w-full p-4 rounded-2xl bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-900 dark:text-white focus:border-blue-500 focus:ring-4 focus:ring-blue-100 dark:focus:ring-blue-900/30 transition-all font-bold"
                                />
                                <p className="text-[10px] text-slate-500 font-medium px-1">Yaşına uygun porsiyon önerileri için kullanacağız.</p>
                            </div>
                        </div>

                        <div className="flex flex-col gap-3 pt-2">
                            <button
                                onClick={handleSubmit}
                                disabled={!childName}
                                className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 disabled:from-slate-300 disabled:to-slate-300 text-white font-black py-4 px-6 rounded-2xl transition-all duration-200 shadow-xl shadow-blue-500/20 active:scale-[0.98] disabled:cursor-not-allowed"
                            >
                                Harika, Kaydet! ❤️
                            </button>
                            <button
                                onClick={() => setHasChild(null)}
                                className="w-full bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 text-slate-600 dark:text-slate-300 font-bold py-4 px-6 rounded-2xl transition-all duration-200 active:scale-[0.98]"
                            >
                                ← Geri dön
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SchoolChildModal;
